export default __webpack_public_path__ + "static/media/Kitchen2.9c23e410.jpeg";